import { Grid } from "@mui/material";
import { Fragment, useEffect, useState } from "react";

import { useAxios } from "../../hooks";
import List from "./list components/List";
import { PageHeader, Pagination } from "../../components";

export default function AdminCampaignRequest() {
  const axios = useAxios();

  const [page, setPage] = useState({ page: 1 });
  const [loading, setLoading] = useState(false);
  const [filterBy, setFilterBy] = useState("ALL");
  const [searchKey, setSearchKey] = useState("");
  const [campaigns, setCampaigns] = useState([]);
  const [lastPage, setLastPage] = useState({ totalCount: 0, lastPage: false });

  useEffect(() => {
    setLoading(true);
    axios({
      url:
        "/get/campaign/requests" +
        `?page=${page.page}&limit=10` +
        (searchKey ? `&search=${encodeURIComponent(searchKey)}` : "") +
        (filterBy ? `&requestStatus=${filterBy}` : ""),
      disableError: true,
    }).then((response) => {
      if (response.status) {
        setCampaigns(response.data.finalCampaignRequest);
        setLastPage({
          totalCount: response.data.totalCounts,
          lastPage: response.data.finalCampaignRequest.length < 10,
        });
      } else {
        setCampaigns([]);
        setLastPage({
          totalCount: 0,
          lastPage: 1,
        });
      }

      setLoading(false);
    });
  }, [axios, filterBy, page.page, searchKey]);

  function handlePagination(step, index) {
    setPage((prev) => ({
      page: step === "index" ? index : prev + (step === "next" ? 1 : -1),
    }));
  }

  return (
    <Fragment>
      <Grid container spacing={3}>
        <Grid size={12}>
          <PageHeader
            pageName={"Campaign Request"}
            pageHeader={"Campaign requested"}
          />
        </Grid>
      </Grid>

      <List
        setSearchKey={setSearchKey}
        campaigns={campaigns}
        loading={loading}
        setPage={setPage}
        filterBy={filterBy}
        setFilterBy={setFilterBy}
      />

      {!!lastPage.totalCount && (
        <Grid item container display={"flex"} justifyContent={"center"}>
          <Pagination
            count={Math.ceil(lastPage.totalCount / 10)}
            variant="outlined"
            color="secondary"
            page={page.page}
            onChange={(e, value) => handlePagination("index", value)}
          />
        </Grid>
      )}
    </Fragment>
  );
}
